import React, { useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { CartProvider } from "./lib/cart";
import { MemberAuthProvider } from "./lib/memberAuth";
import RequireMember from "./lib/RequireMember";

import Home from "./pages/Home";
import Membership from "./pages/Membership";
import MembershipApply from "./pages/MembershipApply";
import Restaurant from "./pages/Restaurant";
import Bar from "./pages/Bar";
import CigarLounge from "./pages/CigarLounge";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Events from "./pages/Events";
import PrivateSpaces from "./pages/PrivateSpaces";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Reservations from "./pages/Reservations";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCheckin from "./pages/AdminCheckin";
import MemberLogin from "./pages/AccountLogin";
import AccountDashboard from "./pages/AccountDashboard";
import LegalPage from "./pages/LegalPage";
import Careers from "./pages/Careers";
import GoogleAuthCallback from "./components/GoogleAuthCallback";
import AgeGate from "./components/AgeGate";
import ComingSoon from "./components/ComingSoon";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function GoogleAuthGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return children;
}

function ComingSoonGate({ children }) {
  const location = useLocation();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({ coming_soon: true }));
  }, []);
  if (location.pathname.startsWith("/admin")) return children;
  if (settings === null) return <div className="min-h-screen bg-[#0A0A0A]" />;
  if (settings.coming_soon) return <ComingSoon />;
  return children;
}

function Layout({ children, hideChrome = false }) {
  return (
    <>
      {!hideChrome && <Navbar />}
      <main className="min-h-screen">{children}</main>
      {!hideChrome && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <CartProvider>
        <MemberAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster theme="dark" position="bottom-right" richColors closeButton />
            <GoogleAuthGate>
            <ComingSoonGate>
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/membership" element={<Layout><AgeGate><Membership /></AgeGate></Layout>} />
              <Route path="/membership/apply" element={<Layout><AgeGate><MembershipApply /></AgeGate></Layout>} />
              <Route path="/restaurant" element={<Layout><Restaurant /></Layout>} />
              <Route path="/bar" element={<Layout><Bar /></Layout>} />
              <Route path="/cigar-lounge" element={<Layout><AgeGate><CigarLounge /></AgeGate></Layout>} />
              <Route path="/shop" element={<Layout><AgeGate><Shop /></AgeGate></Layout>} />
              <Route path="/shop/:id" element={<Layout><AgeGate><ProductDetail /></AgeGate></Layout>} />
              <Route path="/cart" element={<Layout><Cart /></Layout>} />
              <Route path="/checkout/success" element={<Layout><CheckoutSuccess /></Layout>} />
              <Route path="/events" element={<Layout><Events /></Layout>} />
              <Route path="/private-spaces" element={<Layout><PrivateSpaces /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
              <Route path="/contact" element={<Layout><Contact /></Layout>} />
              <Route path="/reservations" element={<Layout><Reservations /></Layout>} />
              <Route path="/account/login" element={<Layout hideChrome><MemberLogin /></Layout>} />
              <Route path="/account" element={<Layout hideChrome><RequireMember><AccountDashboard /></RequireMember></Layout>} />
              <Route path="/member/login" element={<Navigate to="/account/login" replace />} />
              <Route path="/member" element={<Navigate to="/account" replace />} />
              <Route path="/admin" element={<Layout hideChrome><AdminLogin /></Layout>} />
              <Route path="/admin/dashboard" element={<Layout hideChrome><AdminDashboard /></Layout>} />
              <Route path="/admin/checkin" element={<Layout hideChrome><AdminCheckin /></Layout>} />
              <Route path="/privacy" element={<Layout><LegalPage kind="privacy" /></Layout>} />
              <Route path="/terms" element={<Layout><LegalPage kind="terms" /></Layout>} />
              <Route path="/careers" element={<Layout><Careers /></Layout>} />
              <Route path="*" element={<Layout><NotFound /></Layout>} />
            </Routes>
            </ComingSoonGate>
            </GoogleAuthGate>
          </BrowserRouter>
        </MemberAuthProvider>
      </CartProvider>
    </div>
  );
}
